import { getDistance } from '@m1/geo-utils';
import classNames from 'classnames/bind';
import commaNumber from 'comma-number';
import React, { useMemo, useRef, useEffect, useState } from 'react';

import styles from './CellGroup.module.scss';

import { Cell } from '@/components/ui/dashboard/Monitor';
import { MAVLINK_MESSAGE_IDS as MESSAGE } from '@/define/messageId';
import useRobotTelemetry from '@/hooks/useRobotTelemetry';

const cx = classNames.bind(styles);

const CellGroup = ({ robotId }) => {
  const heartbeat = useRobotTelemetry(robotId, MESSAGE.HEARTBEAT);
  const globalPosition = useRobotTelemetry(robotId, MESSAGE.GLOBAL_POSITION_INT);
  const vfrHud = useRobotTelemetry(robotId, MESSAGE.VFR_HUD);
  const homePosition = useRobotTelemetry(robotId, MESSAGE.HOME_POSITION);

  // Distance to Home
  const distanceToHome = useMemo(() => {
    if (!globalPosition) return 0;
    if (!homePosition) return 0;

    return getDistance(globalPosition, homePosition);
  }, [globalPosition, homePosition]);

  // #region Total Distance Traveled
  const prevTimeRef = useRef(null);
  const accumulatedDistance = useRef(0);
  const [totalDistance, setTotalDistance] = useState(0);

  useEffect(() => {
    if (!heartbeat) return;
    if (!vfrHud) return;

    // DISARM 상태에서는 거리 누적 중단
    if (!heartbeat.isArm) {
      prevTimeRef.current = null;
      return;
    }

    const currentTime = Date.now();

    if (prevTimeRef.current !== null) {
      const timeDiff = (currentTime - prevTimeRef.current) / 1000; // 시간 단위 변환
      const distance = vfrHud.groundspeed * timeDiff; // m/s * s = m

      accumulatedDistance.current += distance;
      setTotalDistance(accumulatedDistance.current);
    }

    prevTimeRef.current = currentTime;
  }, [heartbeat, vfrHud]);
  // #endregion

  return (
    <div className={cx('container')}>
      <Cell data={[{ title: 'Distance to Home', value: commaNumber(distanceToHome.toFixed(2)), unit: 'm' }]} />
      <Cell data={[{ title: 'Total Distance', value: commaNumber(totalDistance.toFixed(2)), unit: 'm' }]} />
    </div>
  );
};

export default CellGroup;
